"use client";

let prompt: ((error?: string) => Promise<string | null>) | null = null;
let queue: Promise<unknown> = Promise.resolve();

export function registerCaptchaPrompt(next: typeof prompt) {
  prompt = next;
}

export function requestSubmissionCaptcha(error?: string) {
  return prompt ? prompt(error) : Promise.resolve(null);
}

// Include uploads and server actions in the same queue as API fetch submissions.
export function serializeCaptchaSubmission<T>(
  run: () => Promise<T>,
): Promise<T> {
  const result = queue.then(run, run);
  queue = result.catch(() => undefined);
  return result;
}
